import * as React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Taxonomy } from '@uncinc/react-drupal-core';

import { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';
import { TaxonomyLocation } from '../../types/uncinc_profile/taxonomy';
import Button from '../Button';
import DynamicMediaItem from '../DynamicMediaItem';

import './style.scss';

interface ProjectHeroProps extends React.ComponentPropsWithoutRef<'div'> {
  logo?: MediaReferenceField<'image'>;
  title: string;
  status: string;
  types: string[];
  location: TaxonomyLocation;
  url?: string;
}

const ProjectHero: React.FC<ProjectHeroProps> = (props) => {
  const { t } = useTranslation();

  const {
    className,
    logo,
    title,
    status,
    types,
    location,
    url,
  } = props;

  const classNames = c('ProjectHero', className);

  return (
    <div className={classNames}>
      {logo && (
        <div className="ProjectHero__logo">
          <DynamicMediaItem media={logo} imageAspectRatio="original" />
        </div>
      )}

      <div className="ProjectHero__info">
        <h1 className="ProjectHero__title mb-3">
          {title}
        </h1>

        <p className="ProjectHero__status body--large mb-3">
          {location.field_type[0] && (
            <span>
              {t('pages.node_project.location_type')}: {location.field_type[0].entity.name[0].value}<br />
            </span>
          )}
          {t('pages.node_project.status')}: {status}<br />
          {t('pages.node_project.types')}: {types.join(', ')}
        </p>

        <p className="ProjectHero__address mb-6">
          <Taxonomy
            entity={Immutable.fromJS(location)}
            viewMode="project"
          />
        </p>

        {url && (
          <Button href={url} type="primary" className="w-auto">
            {t('pages.node_project.to_website')}
          </Button>
        )}
      </div>
    </div>
  );
};


export default ProjectHero;
